import { ExtendedValidationMessages } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { EapSettingsCreateModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.model';

export const useEapSettingsErrorValidationMessageForm = () => {
    const { t } = useTranslation();
    const errorMessages: Partial<Record<keyof EapSettingsCreateModel, ExtendedValidationMessages>> = {
        name: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
                'too-long': t('settings.devices.eap-settings.eap-config-create-form.validation.too-long'),
                'pattern-mismatch': t(
                    'settings.devices.eap-settings.eap-config-create-form.validation.pattern-mismatch'
                ),
                duplicated: t('settings.devices.eap-settings.eap-config-create-form.validation.duplicated'),
            },
        },
        ssid: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
                'too-long': t('settings.devices.eap-settings.eap-config-create-form.validation.too-long'),
            },
        },
        username: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
            },
        },
        anonymousUser: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
            },
        },
        clientCertificateFilename: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
            },
        },
        clientPrivateKeyFilename: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
            },
        },
        password: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
            },
        },
        confirmPassword: {
            error: {
                'value-missing': t('settings.devices.eap-settings.eap-config-create-form.validation.value-missing'),
                'pattern-mismatch': t(
                    'settings.devices.eap-settings.eap-config-create-form.validation.password.pattern-mismatch'
                ),
            },
        },
    };

    return { errorMessages };
};
